import { useNavigate } from 'react-router-dom';

export default function ComoFuncionaCTA() {
  const navigate = useNavigate();

  return (
    <section id="cta-final" className="py-20 md:py-32 relative overflow-hidden" style={{ background: '#F7F6FF' }}>
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=abstract%20soft%20purple%20lavender%20gradient%20background%20with%20gentle%20light%20bokeh%20and%20subtle%20geometric%20shapes%2C%20minimal%20and%20elegant%2C%20light%20tones%2C%20no%20people%2C%20artistic%20texture%2C%20pastel%20purple%20and%20white%20palette&width=1440&height=600&seq=cfcta2025&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }} />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(247,246,255,0.88) 0%, rgba(247,246,255,0.96) 100%)' }} />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-[#EEEDFE] text-[#534AB7] text-xs font-semibold px-4 py-2 rounded-full mb-6 tracking-wide uppercase">
          <i className="ri-shield-star-line"></i>
          Empieza hoy
        </div>

        <h2 className="font-title text-3xl md:text-5xl text-[#0A0A0A] leading-tight mb-5">
          Empieza hoy a organizar{' '}
          <span style={{ color: '#534AB7' }}>a tu familia</span>
        </h2>

        <p className="text-[#0A0A0A]/60 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-10 font-light">
          Activa tu membresía Coverly y recibe por WhatsApp tu folio, indicaciones de acceso y seguimiento personalizado.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center mb-10">
          <button
            onClick={() => navigate('/precios')}
            className="inline-flex items-center justify-center gap-2 bg-[#534AB7] hover:bg-[#3C3489] text-white font-semibold px-8 md:px-10 py-4 rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap text-sm md:text-base w-full sm:w-auto min-h-[52px] cursor-pointer"
          >
            <i className="ri-shield-check-line text-base"></i>
            <span>Activar membresía</span>
          </button>
          <a
            href="tel:526675680042"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-2 border border-[#534AB7]/40 text-[#534AB7] font-semibold px-8 md:px-10 py-4 rounded-full hover:bg-[#EEEDFE] transition-all duration-300 whitespace-nowrap text-sm md:text-base w-full sm:w-auto min-h-[52px] cursor-pointer"
          >
            <i className="ri-phone-line text-base"></i>
            <span>Hablar con un asesor</span>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {[
            { icon: 'ri-lock-2-line', text: 'Precio de registro 2026' },
            { icon: 'ri-whatsapp-line', text: 'Folio por WhatsApp' },
            { icon: 'ri-map-pin-line', text: 'Red aliada por zona' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2">
              <i className={`${item.icon} text-[#534AB7] text-sm`}></i>
              <span className="text-[#0A0A0A]/50 text-xs md:text-sm font-light">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
